import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('issueFormAssets', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_forms/fragments/assets/assets.html'),
        controller: 'IssueFormAssetsController',
        controllerAs: 'IssueFormAssetsCtrl',
        bindings: {
            isFullWidth: '<', // boolean
            availableAssets: '<',
            selectedAsset: '=',
            showSubAssetInput: '<', // boolean
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/assets/assets.component.ts